// WP12 read layer hook — loads the ACTIVE authoritative WP11 package objects.
// This is the only authoritative v2.5 data source; no POC fallbacks.
import { useEffect, useState } from "react";
import { API, apiGet } from "../lib/api";

export const useWp12 = (surface) => {
    const [state, setState] = useState({ status: "loading", data: null, packageId: null, error: null });
    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const res = await apiGet(`${API}/wp12/${surface}`);
                if (cancelled) return;
                if (res.error) { setState({ status: "error", data: null, packageId: null, error: res.error }); return; }
                setState({ status: "ready", data: res.data.data, packageId: res.data.publicationPackageId, error: null });
            } catch (e) {
                if (!cancelled) setState({ status: "error", data: null, packageId: null, error: e?.message || "load failed" });
            }
        })();
        return () => { cancelled = true; };
    }, [surface]);
    return state;
};
